export const EXPERIMENTS_SCOPE = 'wix-social-blog';
